/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ICreateBoxArgs } from "./components";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PLATFORM_FEE_CONFIG } from "./graphql/getPlatformFeeConfig.query";

const is = require("is_js");

const SERVICE_NAME = "CostumePageService";
const log: any = LoggerModule.getInstance();

export class CostumePageService {
  private static instance: CostumePageService;
  private vapp: VApplication;
  private selectedCostume: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CostumePageService {
    if (!CostumePageService.instance) {
      CostumePageService.instance = new CostumePageService(props);
    }
    return CostumePageService.instance;
  }

  public setSelectedCostume(data: any) {
    console.log("datadatadatadata", data);
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentation() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPresentation();

    console.log(content);
    return content;
  }
  public async getPreBookedAmt() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPreBookedAmt();

    return content;
  }

  public async getCostumeType(args: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(args);

    return content;
  }

  public async getCities() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    // compProps = await agent.getCities();
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }
    compProps = await agent.getMyProfile();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log("content96====", content);
    return content;
  }

  public async getAllCarts() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getAllCarts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log("formatted res?.data?.getAllCarts", content);
    return content;
  }

  public async createBox(payload: ICreateBoxArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createBox(payload);

    return content;
  }
  public async createPayFAC(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.createPayFAC({ ...arg });
    return content;
  }
  public async updateMailAddress(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.updateBox(arg);
    return content;
  }

  public async deleteCart(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.deleteCart(arg);
    return content;
  }

  public async addToCart(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.AddToCart(arg);
    return content;
  }

  public async createMultiBox(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.CreateMultiBox(arg);
    return content;
  }

  public async createMultiBoxCamp(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.CreateMultiBoxCamp(arg);
    return content;
  }

  public async validateDiscount(args: any) {
    console.log(args);
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.validateDiscount(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPlatformFeeConfig() {
    const graphqlModule = this.vapp.getSync("services.GraphqlServerModule") as GraphqlServerModule;
    const client = graphqlModule.getClient("graphql-gateway");
    if (client) {
      const res = await client.query({
        query: GET_PLATFORM_FEE_CONFIG,
        fetchPolicy: "network-only",
      });
      return res?.data?.getPlatformFeeConfig;
    }
    return null;
  }

  public async cybersourceSetupPayerAuth(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.cybersourceSetupPayerAuth(args);

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async createTransaction(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.createTransaction(args);

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async cybersourceComplete3ds(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.cybersourceComplete3ds(args);

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
